import * as source from "./source";

export function getPopulationCount(id, req) {
  return function (dispactch) {
    dispactch({
      type: "GET_POPULATION_COUNT",
      payload: source.getPopulationCount(id, req),
    });
  };
}
export function getMaleCount(id, req) {
  return function (dispactch) {
    dispactch({
      type: "GET_MALE_POPULATION_COUNT",
      payload: source.getMalePopulationCount(id, req),
    });
  };
}
export function getFemaleCount(id, req) {
  return function (dispactch) {
    dispactch({
      type: "GET_FAMALE_POPULATION_COUNT",
      payload: source.getFemalePopulationCount(id, req),
    });
  };
}
export function getTransgenderCount(id, req) {
  return function (dispactch) {
    dispactch({
      type: "GET_TRANSGENDER_POPULATION",
      payload: source.getTransgenderCount(id, req),
    });
  };
}

export const createTodo = (data) => {
  return {
    type: "CREATE_TODO",
    payload: source.addTodo(data),
  };
};
export const getUserTodoById = (id) => {
  return {
    type: "GET_USER_TODO",
    payload: source.getUserTodo(id),
  };
};
export const deleteTodoById = (id) => {
  return {
    type: "DELETE_TODO",
    payload: source.delteTodoById(id),
  };
};
export const editTodoById = (id, data) => {
  return {
    type: "EDIT_TODO",
    payload: source.updateTodoById(id, data),
  };
};
export const editUser = (id, data) => {
  return {
    type: "EDIT_USER",
    payload: source.editUser(id, data),
  };
};
export function uploadProfile(userId, formBody) {
  return {
    type: "UPLOAD_PROFILE",
    payload: source.uploadProfile(userId, formBody),
  };
}

export const getUserById = (id) => {
  return {
    type: "GET_USER_BY_ID",
    payload: source.getUserById(id),
  };
};

export const getNotification = () => {
  return {
    type: "GET_NOTIFICATION",
    payload: source.finalNotifiaction(),
  };
};
export const getNotificationPreg = () => {
  return {
    type: "GET_NOTIFICATION_PREG",
    payload: source.finalNotifiactionPreg(),
  };
};
